module.exports = __webpack_public_path__ + "img/official-tag.da9f3b48.png";